import * as React from 'react';
import { connect } from 'react-redux';

import AppCta from '../AppCta';
import SignupCta from '../SignupCta';

export interface Props {
  cta: string | null;
  headerText?: string;
  subText?: string;
  subText2?: string;
  topper: boolean;
  token?: string;
}

export const Cta = (props: Props) => (
  <div
    className="row center-xs bottom-xs"
    id="cta"
    style={{ paddingBottom: 0, position: 'relative', width: '100%' }}
  >
    {props.token || props.cta === 'app' ? (
      <AppCta topper={props.topper} />
    ) : (
      <SignupCta
        headerText={props.headerText}
        subText={props.subText}
        subText2={props.subText2}
        topper={props.topper}
      />
    )}
  </div>
);

const mapStateToProps = (state: any) => ({
  cta: state.auth.cta,
  token: state.auth.token,
});

export default connect(mapStateToProps)(Cta);
